import styled from "styled-components";

import EmphasizedSection from "components/EmphasizedSection";

import { Message } from "uikit/Modal/styles";

import SubscriptionPricingSection from "../SubscriptionPricingSection";
import { PlanSectionInner } from "../SubscriptionPricingSection/styles";

export const StyledEmphasizedSection = styled(EmphasizedSection)`
  width: fit-content;
  padding: ${({ theme }) => theme.padding.p8} ${({ theme }) => theme.padding.p12};
  border-radius: 100px;
  margin: 0 auto;
`;

export const FreeTrialEndedModalContent = styled.div`
  ${Message} {
    margin-bottom: ${({ theme }) => theme.margin.m12};
  }
`;

export const PricingSectionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.margin.m24};
`;

export const StyledSubscriptionPricingSection = styled(SubscriptionPricingSection)`
  background-color: ${({ theme }) => theme.colors.colorsNew.blue.light_blue};
  border: none;
  border-radius: 16px;
  margin-bottom: ${({ theme }) => theme.margin.m12};
  width: 380px;

  ${PlanSectionInner} {
    border: inherit;
    background-color: inherit;
  }
`;
